import { render, staticRenderFns } from "./supply-company-pass.vue?vue&type=template&id=bb9fd03a&scoped=true&"
import script from "./supply-company-pass.vue?vue&type=script&lang=js&"
export * from "./supply-company-pass.vue?vue&type=script&lang=js&"
import style0 from "./supply-company-pass.vue?vue&type=style&index=0&id=bb9fd03a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9fd03a",
  null
  
)

export default component.exports